/**
 * Custom Product Page JavaScript
 * ---------------------------------
 *
 * This file handles the custom product page functionality including:
 * - Product image slider with touch/keyboard/mouse support
 * - Buy Now button functionality (clears cart, adds product, redirects to checkout)
 * - Add to Cart button loading state management
 * - Cart integration with Dawn theme patterns
 * - Accessibility features for the product page
 *
 * @requires product-form.js (Dawn theme web component)
 */

// Dead code removed - using function-based approach // END DISABLED CLASS

// Custom Product Page JavaScript
document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom Product Page JS loaded');
  
  // Initialize custom loading spinners for all buttons
  initializeCustomSpinners();
  
  // Check if payment button rendered after a delay
  setTimeout(function() {
    const paymentButton = document.querySelector('.shopify-payment-button');
    const fallback = document.querySelector('.payment-button-fallback');
    
    if (!paymentButton || paymentButton.children.length === 0) {
      console.log('Payment button not found, showing fallback');
      if (fallback) {
        fallback.style.display = 'block';
        // Setup loading state for fallback button
        setupFallbackButtonLoading();
      }
    } else {
      console.log('Payment button found:', paymentButton);
      // Add loading state handling for payment button
      setupPaymentButtonLoading();
    }
  }, 2000);
  
  // Initialize image slider
  initImageSlider();
  
  // Initialize quantity selector
  initQuantitySelector();
  
  // Initialize variant selector
  initVariantSelector();
  
  // Initialize custom variant picker
  initCustomVariantPicker();
  
  // Setup form completion handler for Dawn integration
  setupDawnFormIntegration();
  
  // Ensure loading overlay is properly hidden after all initialization
  setTimeout(() => {
    resetAllLoadingStates();
    console.log('Final loading state reset completed');
  }, 200);
});

// After DOMContentLoaded block, add cross-page reset listeners
window.addEventListener('pageshow', (event) => {
  // Reset all loading states on page show (including back navigation)
  resetAllLoadingStates();
  
  // Additional check for persisted pages (bfcache)
  if (event.persisted) {
    console.log('Page restored from bfcache - resetting all states');
    resetAllLoadingStates();
  }
});

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    // Reset loading states when page becomes visible
    resetAllLoadingStates();
  }
});

// Enhanced error detection for accelerated checkout failures
document.addEventListener('DOMContentLoaded', function() {
  // Listen for checkout errors using MutationObserver (works with shadow DOM)
  observeCheckoutErrors();
  
  // Enhanced focus/blur detection for checkout failures
  setupCheckoutErrorDetection();
});

// Additional safeguard: Hide loading overlay when page fully loads
window.addEventListener('load', function() {
  // Small delay to ensure all scripts have executed
  setTimeout(() => {
    hidePageLoading();
    console.log('Page fully loaded - ensuring loading overlay is hidden');
  }, 100);
});

// Initialize custom white spinners for all buttons
function initializeCustomSpinners() {
  // Add to Cart button
  const addToCartButton = document.querySelector('.custom_add_to_cart');
  if (addToCartButton && !addToCartButton.querySelector('.custom_loading_spinner')) {
    const spinner = document.createElement('div');
    spinner.className = 'custom_loading_spinner';
    addToCartButton.appendChild(spinner);
  }
  
  // REMOVED: Payment button spinner injection - following Shopify standards
  // The accelerated checkout button handles its own loading states
}

// Setup Dawn form integration - work with Dawn's loading states
function setupDawnFormIntegration() {
  const productForm = document.querySelector('product-form');
  if (!productForm) return;
  
  const addToCartButton = document.querySelector('.custom_add_to_cart');
  if (!addToCartButton) return;
  
  // Listen for pubsub cart events (Dawn's event system)
  if (window.PUB_SUB_EVENTS) {
    // Cart update successful - reset loading state
    document.addEventListener(window.PUB_SUB_EVENTS.cartUpdate, function() {
      resetAllLoadingStates();
    });
    
    // Cart error - reset loading state 
    document.addEventListener(window.PUB_SUB_EVENTS.cartError, function() {
      resetAllLoadingStates();
    });
  }
  
  // Fallback: Listen for general cart update events
  document.addEventListener('cart:updated', function() {
    resetAllLoadingStates();
  });
  
  // Reset loading states after a short delay as failsafe
  // This ensures buttons are re-enabled even if events don't fire
  const form = addToCartButton.closest('form');
  if (form) {
    form.addEventListener('submit', function(e) {
      // Use a longer timeout to allow Dawn's submission to complete
      setTimeout(function() {
        // Only reset if we're not on the cart page (successful add to cart)
        if (!window.location.pathname.includes('/cart')) {
          resetAllLoadingStates();
        }
      }, 3000); // 3 seconds should be enough for cart submission
    });
  }
  
  // Setup page-level loading for Buy-Now navigation
  setupPageLoadingIndicator();
}

// Reset button loading state
function resetButtonLoadingState(button) {
  if (button) {
    button.classList.remove('loading');
    button.disabled = false;
    button.removeAttribute('aria-disabled');
  }
}

// Enhanced: Reset all loading states (buttons + page overlay)
function resetAllLoadingStates() {
  // Reset fallback button
  const fallbackButton = document.querySelector('.custom_buy_now_btn');
  resetButtonLoadingState(fallbackButton);
  
  // Reset add to cart button
  const addToCartButton = document.querySelector('.custom_add_to_cart');
  resetButtonLoadingState(addToCartButton);
  
  // Reset page-level loading overlay
  hidePageLoading();
  
  console.log('All loading states reset');
}

// Legacy function for backwards compatibility
function resetBuyNowButtons() {
  resetAllLoadingStates();
}

// Enhanced error detection for checkout failures
function observeCheckoutErrors() {
  // Watch for error popups, alerts, or modal dismissals
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        // Check for error-related elements being added
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Look for common error indicators
            const errorSelectors = [
              '[data-error]',
              '.error',
              '.alert',
              '[role="alert"]',
              '.shopify-payment-button__error',
              '[aria-live="assertive"]'
            ];
            
            if (errorSelectors.some(selector => node.matches && node.matches(selector))) {
              console.log('Checkout error detected via DOM mutation');
              resetAllLoadingStates();
            }
          }
        });
      }
    });
  });
  
  // Observe the entire document for error-related changes
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-error', 'aria-live', 'role']
  });
}

// Enhanced focus/blur detection for checkout failures
function setupCheckoutErrorDetection() {
  // Listen for window focus events (user returns from failed checkout)
  window.addEventListener('focus', function() {
    // Small delay to ensure any checkout processes have completed
    setTimeout(() => {
      // Check if we're still on the product page (not redirected)
      if (window.location.pathname.includes('/products/')) {
        console.log('Window focused on product page - likely checkout error');
        resetAllLoadingStates();
      }
    }, 500);
  });
  
  // Listen for popstate events (back button navigation)
  window.addEventListener('popstate', function() {
    console.log('Navigation detected - resetting loading states');
    resetAllLoadingStates();
  });
  
  // Enhanced click detection outside payment buttons (modal dismissal)
  document.addEventListener('click', function(event) {
    // If clicking outside payment areas while loading is active
    const isPaymentButton = event.target.closest('shopify-accelerated-checkout, .shopify-payment-button, .custom_buy_now_btn');
    const isPageLoading = document.querySelector('.page-loading-overlay.visible');
    
    if (!isPaymentButton && isPageLoading) {
      // User clicked outside payment area while loading - likely dismissing error
      setTimeout(() => {
        resetAllLoadingStates();
      }, 100);
    }
  });
}

// Setup loading state for Payment Button (Buy Now) - RESPONDS TO ACTUAL REDIRECT
function setupPaymentButtonLoading() {
  const paymentButton = document.querySelector('.shopify-payment-button__button');
  if (!paymentButton) return;
  
  // REMOVED: Custom DOM manipulation - following Shopify accelerated checkout standards
  // The wallet button now handles its own loading states internally via shadow DOM
  console.log('Payment button found - relying on native loading behavior');
}

// SHOPIFY STANDARD: Buy Now Fallback Function
// Follows Shopify Cart AJAX API documentation
window.buyNowFallback = function(formId) {
  console.log('Buy Now fallback triggered');
  
  const fallbackButton = document.querySelector('.custom_buy_now_btn');
  const productForm = document.getElementById(formId);
  
  if (!productForm || !fallbackButton) {
    console.error('Form or button not found');
    return;
  }

  // Show loading state immediately
  fallbackButton.classList.add('loading');
  fallbackButton.disabled = true;
  fallbackButton.setAttribute('aria-disabled', 'true');

  try {
    // Step 1: Get form data (variant ID, quantity, properties)
    const formData = new FormData(productForm);
    
    // Step 2: Add product to cart using Shopify Cart AJAX API
    // Use locale-aware URLs as per Shopify documentation
    const cartAddUrl = (window.Shopify && window.Shopify.routes) 
      ? window.Shopify.routes.root + 'cart/add.js' 
      : '/cart/add.js';
      
    fetch(cartAddUrl, {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error('Failed to add product to cart');
      }
    })
    .then(data => {
      console.log('Product added to cart successfully:', data);
      
      // Step 3: Redirect to cart (Shopify standard practice)
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Cart add failed:', error);
      resetButtonLoadingState(fallbackButton);
      
      // Show user-friendly error (optional)
      alert('Unable to add product to cart. Please try again.');
    });
    
  } catch (error) {
    console.error('Buy now fallback error:', error);
    resetButtonLoadingState(fallbackButton);
  }
};

// Setup loading state for Fallback Button (Buy Now) - RESPONDS TO ACTUAL REDIRECT
function setupFallbackButtonLoading() {
  const fallbackButton = document.querySelector('.custom_buy_now_btn');
  if (!fallbackButton) return;

  // Add custom spinner if not present (for dynamic styling)
  if (!fallbackButton.querySelector('.custom_loading_spinner')) {
    const spinner = document.createElement('div');
    spinner.className = 'custom_loading_spinner';
    fallbackButton.appendChild(spinner);
  }

  // Note: Click handling is now done via onclick="buyNowFallback()" in HTML
  // This maintains consistency with Shopify's standard approach
}

// Image slider functionality - Enhanced with auto-slide following Shopify standards
function initImageSlider() {
  try {
    const sliderContainer = document.querySelector('.custom_product_images');
    if (!sliderContainer) return;
    
    const slides = sliderContainer.querySelectorAll('.custom_slide');
    const dots = sliderContainer.querySelectorAll('.custom_dot');
    
    if (slides.length === 0) return;
    
    let currentSlide = 0;
    
    // Auto-slide functionality following Shopify accessibility guidelines
    let autoSlideInterval = null;
    let isUserInteracting = false;
    let isPaused = false;
    const SLIDE_INTERVAL = 4000; // 4 seconds as requested
    
    // Check if user prefers reduced motion (Shopify accessibility requirement)
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  // Function to pause all videos
  function pauseAllVideos() {
    const videos = sliderContainer.querySelectorAll('video');
    videos.forEach(video => {
      if (!video.paused) {
        video.pause();
      }
    });
  }

  // Function to check if any video is currently playing
  function hasPlayingVideo() {
    const videos = sliderContainer.querySelectorAll('video');
    return Array.from(videos).some(video => !video.paused);
  }
  
  // Function to go to specific slide
  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    
    currentSlide = index;
    console.log('Going to slide:', index);
    
    // Pause all videos when changing slides
    pauseAllVideos();
    
    // Hide all slides
    slides.forEach((slide, i) => {
      slide.style.display = i === index ? 'block' : 'none';
    });
    
    // Update dots
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
      dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      dot.setAttribute('tabindex', i === index ? '0' : '-1');
    });

    // Announce to screen readers
    announceImageChange(index, slides.length);
    
    console.log('Slide updated successfully');
  }

  // Auto-slide functions
  function startAutoSlide() {
    if (prefersReducedMotion || slides.length <= 1 || isPaused) return;
    
    stopAutoSlide(); // Clear any existing interval
    
    autoSlideInterval = setInterval(() => {
      // Don't auto-slide if user is interacting or videos are playing
      if (isUserInteracting || hasPlayingVideo()) return;
      
      const nextIndex = (currentSlide + 1) % slides.length;
      goToSlide(nextIndex);
    }, SLIDE_INTERVAL);
    
    console.log('Auto-slide started');
  }

  function stopAutoSlide() {
    if (autoSlideInterval) {
      clearInterval(autoSlideInterval);
      autoSlideInterval = null;
      console.log('Auto-slide stopped');
    }
  }

  function pauseAutoSlide() {
    isPaused = true;
    stopAutoSlide();
    console.log('Auto-slide paused');
  }

  function resumeAutoSlide() {
    isPaused = false;
    if (!prefersReducedMotion && slides.length > 1) {
      startAutoSlide();
      console.log('Auto-slide resumed');
    }
  }
  
  // Initialize first slide
  console.log('Initializing first slide');
  goToSlide(0);
  
  // Enhanced dot click handlers with auto-slide integration
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      console.log('Dot clicked:', index);
      isUserInteracting = true;
      goToSlide(index);
      stopAutoSlide();
      // Resume auto-slide after user interaction timeout
      setTimeout(() => {
        isUserInteracting = false;
        resumeAutoSlide();
      }, 8000); // 8 seconds pause after user interaction
    });
    
    dot.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (e.key === ' ' && e.target.classList.contains('custom_dot')) {
          // Spacebar on dot toggles auto-slide
          if (isPaused) {
            resumeAutoSlide();
          } else {
            pauseAutoSlide();
          }
        } else {
          isUserInteracting = true;
        goToSlide(index);
          stopAutoSlide();
          setTimeout(() => {
            isUserInteracting = false;
            resumeAutoSlide();
          }, 8000);
        }
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        isUserInteracting = true;
        goToSlide(index - 1);
        stopAutoSlide();
        setTimeout(() => {
          isUserInteracting = false;
          resumeAutoSlide();
        }, 8000);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        isUserInteracting = true;
        goToSlide(index + 1);
        stopAutoSlide();
        setTimeout(() => {
          isUserInteracting = false;
          resumeAutoSlide();
        }, 8000);
      }
    });
  });
  
  // Enhanced touch/swipe support with auto-slide integration
  let startX = 0;
  let endX = 0;
  
  sliderContainer.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isUserInteracting = true;
    pauseAutoSlide();
  }, { passive: true });
  
  sliderContainer.addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;
    const threshold = 50;
    
    if (Math.abs(diffX) > threshold) {
      if (diffX > 0) {
        goToSlide(currentSlide + 1);
      } else {
        goToSlide(currentSlide - 1);
      }
    }
    
    // Resume auto-slide after touch interaction
    setTimeout(() => {
      isUserInteracting = false;
      resumeAutoSlide();
    }, 8000);
  }, { passive: true });
  
  // Enhanced keyboard navigation with auto-slide integration
  sliderContainer.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      isUserInteracting = true;
      goToSlide(currentSlide - 1);
      stopAutoSlide();
      setTimeout(() => {
        isUserInteracting = false;
        resumeAutoSlide();
      }, 8000);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      isUserInteracting = true;
      goToSlide(currentSlide + 1);
      stopAutoSlide();
      setTimeout(() => {
        isUserInteracting = false;
        resumeAutoSlide();
      }, 8000);
    }
  });
  
  // Add pause/resume on hover (Shopify UX best practice)
  sliderContainer.addEventListener('mouseenter', () => {
    isUserInteracting = true;
    pauseAutoSlide();
  });

  sliderContainer.addEventListener('mouseleave', () => {
    isUserInteracting = false;
    resumeAutoSlide();
  });

  // Pause auto-slide when user focuses on interactive elements
  sliderContainer.addEventListener('focusin', () => {
    isUserInteracting = true;
    pauseAutoSlide();
  });

  sliderContainer.addEventListener('focusout', () => {
    isUserInteracting = false;
    setTimeout(() => {
      if (!isUserInteracting) {
        resumeAutoSlide();
      }
    }, 1000);
  });

  // Listen for video play/pause events to control auto-slide
  sliderContainer.addEventListener('play', (e) => {
    if (e.target.tagName === 'VIDEO') {
      pauseAutoSlide();
      console.log('Video started playing, auto-slide paused');
    }
  }, true);

  sliderContainer.addEventListener('pause', (e) => {
    if (e.target.tagName === 'VIDEO') {
      // Resume auto-slide only if no other videos are playing
      setTimeout(() => {
        if (!hasPlayingVideo() && !isUserInteracting) {
          resumeAutoSlide();
          console.log('Video paused, auto-slide resumed');
        }
      }, 1000);
    }
  }, true);

  // Add visibility change listener to pause when tab is not visible
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      pauseAutoSlide();
      console.log('Tab hidden, auto-slide paused');
    } else if (!isUserInteracting && !hasPlayingVideo()) {
      resumeAutoSlide();
      console.log('Tab visible, auto-slide resumed');
    }
  });
  
  // Handle video interactions following Shopify UX guidelines
  const videos = sliderContainer.querySelectorAll('video');
  videos.forEach(video => {
    // Ensure videos start paused (following UX guidelines)
    video.pause();
    
    // Add play button overlay for better UX
    const wrapper = video.closest('.custom_img_wrapper');
    if (wrapper && !wrapper.querySelector('.video-play-overlay')) {
      const playOverlay = document.createElement('button');
      playOverlay.className = 'video-play-overlay';
      playOverlay.innerHTML = `
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="24" fill="rgba(0,0,0,0.7)"/>
          <path d="M32 24L18 32V16L32 24Z" fill="white"/>
        </svg>
      `;
      playOverlay.setAttribute('aria-label', 'Play video');
      
      playOverlay.addEventListener('click', function(e) {
        e.preventDefault();
        if (video.paused) {
          pauseAllVideos(); // Pause other videos first
          video.play();
          playOverlay.style.display = 'none';
        }
      });

      video.addEventListener('play', function() {
        playOverlay.style.display = 'none';
      });

      video.addEventListener('pause', function() {
        playOverlay.style.display = 'flex';
      });

      wrapper.style.position = 'relative';
      wrapper.appendChild(playOverlay);
    }
  });

  // Initialize auto-slide functionality
  if (!prefersReducedMotion && slides.length > 1) {
    // Start auto-slide after a delay to allow initial load
    setTimeout(() => {
      startAutoSlide();
    }, SLIDE_INTERVAL); // Wait one interval before starting auto-slide
    console.log('Auto-slide will start in', SLIDE_INTERVAL / 1000, 'seconds');
  } else if (prefersReducedMotion) {
    console.log('Auto-slide disabled: User prefers reduced motion');
  } else {
    console.log('Auto-slide disabled: Only one slide available');
  }
  
      // Add live region for screen reader announcements
    createLiveRegion();
    
    console.log('Image slider initialized successfully with auto-slide support');
  } catch (error) {
    console.error('Error initializing image slider:', error);
  }
}

// Create ARIA live region for screen reader announcements
function createLiveRegion() {
  if (document.getElementById('product-image-live-region')) return;
  
  const liveRegion = document.createElement('div');
  liveRegion.id = 'product-image-live-region';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
  liveRegion.className = 'visually-hidden';
      document.body.appendChild(liveRegion);
    }

// Announce image changes to screen readers
function announceImageChange(currentIndex, totalImages) {
  const liveRegion = document.getElementById('product-image-live-region');
  if (liveRegion) {
    liveRegion.textContent = `Product image ${currentIndex + 1} of ${totalImages}`;
  }
}

// Quantity selector functionality
function initQuantitySelector() {
  const quantityInput = document.querySelector('.custom_quantity_input');
  const minusBtn = document.querySelector('.custom_quantity_minus');
  const plusBtn = document.querySelector('.custom_quantity_plus');
  
  if (!quantityInput || !minusBtn || !plusBtn) return;
  
  minusBtn.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value) || 1;
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
    }
  });
  
  plusBtn.addEventListener('click', () => {
    const currentValue = parseInt(quantityInput.value) || 1;
    quantityInput.value = currentValue + 1;
  });
}

// Custom Variant Picker functionality
function initCustomVariantPicker() {
  try {
    const variantPicker = document.querySelector('.custom_variant_picker');
    if (!variantPicker) return;

    const variantDataScript = document.querySelector('[id^="variant-data-"]');
    if (!variantDataScript) return;

    const variantData = JSON.parse(variantDataScript.textContent);
    const { variants, options, currentVariant } = variantData;

    // Get all variant inputs (now all horizontal buttons)
    const horizontalInputs = variantPicker.querySelectorAll('.variant_horizontal_input');
    
    // Get the hidden variant ID input
    const variantIdInput = document.querySelector('.product-variant-id');
    
    // Function to get currently selected options
    function getSelectedOptions() {
      const selected = {};
      
      // Get all selected horizontal inputs
      horizontalInputs.forEach(input => {
        if (input.checked) {
          selected[input.dataset.optionPosition] = input.dataset.optionValue;
        }
      });
      
      return selected;
    }
    
    // Function to find matching variant
    function findMatchingVariant(selectedOptions) {
      return variants.find(variant => {
        const option1Match = !selectedOptions['1'] || variant.option1 === selectedOptions['1'];
        const option2Match = !selectedOptions['2'] || variant.option2 === selectedOptions['2'];
        const option3Match = !selectedOptions['3'] || variant.option3 === selectedOptions['3'];
        
        return option1Match && option2Match && option3Match;
      });
    }
    
    // Function to update variant
    function updateVariant() {
      const selectedOptions = getSelectedOptions();
      const matchingVariant = findMatchingVariant(selectedOptions);
      
      if (matchingVariant && variantIdInput) {
        // Update hidden input
        variantIdInput.value = matchingVariant.id;
        
        // Update price if available
        updateVariantPrice(matchingVariant);
        
        // Update images if available
        updateVariantImages(matchingVariant);
        
        // Update availability
        updateVariantAvailability(matchingVariant);
        
        console.log('Variant updated:', matchingVariant);
      }
    }
    
    // Function to update price display
    function updateVariantPrice(variant) {
      const priceElements = document.querySelectorAll('.current_price');
      const mrpElements = document.querySelectorAll('.mrp');
      
      priceElements.forEach(el => {
        el.textContent = formatMoney(variant.price);
      });
      
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        mrpElements.forEach(el => {
          el.textContent = `MRP: ${formatMoney(variant.compare_at_price)}`;
          el.style.display = 'inline';
        });
      } else {
        mrpElements.forEach(el => {
          el.style.display = 'none';
        });
      }
    }
    
    // Function to update variant images
    function updateVariantImages(variant) {
      if (!variant.featured_image) return;
      
      const slides = document.querySelectorAll('.custom_slide');
      
      // Find the slide with the variant image
      slides.forEach((slide, index) => {
        const img = slide.querySelector('img');
        if (img && img.src.includes(variant.featured_image.id.toString())) {
          // Manually trigger slide change
          changeToSlide(index);
        }
      });
    }
    
    // Helper function to change slide (local to variant picker)
    function changeToSlide(index) {
      const slides = document.querySelectorAll('.custom_slide');
      const dots = document.querySelectorAll('.custom_dot');
      
      if (slides.length === 0) return;
      
      // Hide all slides
      slides.forEach((slide, i) => {
        slide.style.display = i === index ? 'block' : 'none';
      });
      
      // Update dots
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        dot.setAttribute('tabindex', i === index ? '0' : '-1');
      });
      
      // Announce to screen readers
      announceImageChange(index, slides.length);
    }
    
    // Function to update availability
    function updateVariantAvailability(variant) {
      const addToCartButton = document.querySelector('.custom_add_to_cart');
      const buyNowButton = document.querySelector('.shopify-payment-button__button');
      
      if (addToCartButton) {
        if (variant.available) {
          addToCartButton.disabled = false;
          addToCartButton.querySelector('span').textContent = 'Add to Cart';
        } else {
          addToCartButton.disabled = true;
          addToCartButton.querySelector('span').textContent = 'Sold Out';
        }
      }
      
      if (buyNowButton) {
        // rely on wallet button's own availability logic; avoid forcing disabled state
        if (!variant.available) {
          buyNowButton.setAttribute('aria-disabled','true');
        } else {
          buyNowButton.removeAttribute('aria-disabled');
        }
      }
    }
    
    // Simple money formatting
    function formatMoney(cents) {
      return `₹${(cents / 100).toFixed(2)}`;
    }
    
    // Add event listeners to all horizontal inputs
    horizontalInputs.forEach(input => {
      input.addEventListener('change', updateVariant);
    });
    
    // Initialize with current variant
    if (currentVariant && variantIdInput) {
      variantIdInput.value = currentVariant.id;
    }
    
    console.log('Custom variant picker initialized successfully');
    
  } catch (error) {
    console.error('Error initializing custom variant picker:', error);
  }
}

// Legacy variant selector functionality (kept for compatibility)
function initVariantSelector() {
  const variantSelectors = document.querySelectorAll('.custom_variant_selector');
  
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      const selectedOption = this.value;
      const variantId = this.getAttribute('data-variant-id');
      
      // Update hidden variant input
      const variantInput = document.querySelector('.product-variant-id');
      if (variantInput && variantId) {
        variantInput.value = variantId;
      }
      
      console.log('Legacy variant selected:', selectedOption);
    });
  });
}

// CustomProductPage class initialization removed - using function-based approach instead

/**
 * Toggle Product Description Accordion
 * @param {string} sectionId - The section ID for unique identification
 */
function toggleDescription(sectionId) {
  const content = document.getElementById(`description-content-${sectionId}`);
  const header = document.getElementById(`description-toggle-${sectionId}`);
  
  if (!content || !header) return;
  
  const isExpanded = header.getAttribute('aria-expanded') === 'true';
  
  if (isExpanded) {
    // Collapse
    content.classList.remove('expanded');
    content.classList.add('collapsed');
    header.setAttribute('aria-expanded', 'false');
  } else {
    // Expand
    content.classList.remove('collapsed');
    content.classList.add('expanded');
    header.setAttribute('aria-expanded', 'true');
  }
}

// Make toggleDescription available globally for onclick handlers
window.toggleDescription = toggleDescription;



// Initialize description sections on page load
document.addEventListener('DOMContentLoaded', () => {
  // Check if description sections need accordion functionality
  const descriptionSections = document.querySelectorAll('.custom_product_description');
  
  descriptionSections.forEach(section => {
    const content = section.querySelector('.description_content');
    const header = section.querySelector('.description_accordion_header');
    
    if (content && header) {
      // Temporarily expand to measure full height
      content.classList.remove('collapsed');
      const fullHeight = content.scrollHeight;
      content.classList.add('collapsed');
      
      // If content is short enough to fit in collapsed state, show it expanded and make header non-interactive
      if (fullHeight <= 80) { // 4.8rem ≈ 80px (allowing some buffer)
        content.classList.remove('collapsed');
        header.style.cursor = 'default';
        header.onclick = null;
        header.setAttribute('aria-expanded', 'true');
        
        // Hide the toggle text for short content
        const toggleText = header.querySelector('.description_toggle_text');
        if (toggleText) {
          toggleText.style.display = 'none';
        }
      }
    }
  });
});

// Provide fallback for no-JS users
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('custom-product-form');
  if (form && !window.customProductPageJS) {
    // Enable basic form submission if JS fails to load
    form.addEventListener('submit', (e) => {
      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }
    });
  }
  window.customProductPageJS = true;
});

// SHOPIFY STANDARD: Page-level loading indicator for navigation
// Enhanced with better error handling and state management
let pageLoadingOverlay = null;
let loadingTimeout = null;

function setupPageLoadingIndicator() {
  // Create loading overlay element with Shopify standard spinner
  pageLoadingOverlay = document.createElement('div');
  pageLoadingOverlay.className = 'page-loading-overlay';
  pageLoadingOverlay.innerHTML = `
    <div class="page-loading-content">
      <div class="page-loading-spinner">
        <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
          <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/>
        </svg>
      </div>
      <span class="page-loading-text">Loading checkout...</span>
    </div>
  `;
  pageLoadingOverlay.setAttribute('aria-hidden', 'true');
  pageLoadingOverlay.setAttribute('aria-labelledby', 'loading-text');
  
  // Add id for accessibility
  const loadingText = pageLoadingOverlay.querySelector('.page-loading-text');
  if (loadingText) {
    loadingText.id = 'loading-text';
  }
  
  document.body.appendChild(pageLoadingOverlay);
  
  // Enhanced: Listen for wallet button clicks with better shadow DOM support
  document.addEventListener('click', function(event) {
    // Check if click is on or within accelerated checkout button
    const target = event.target.closest('shopify-accelerated-checkout, .shopify-payment-button, shopify-accelerated-checkout-cart');
    if (target) {
      console.log('Accelerated checkout button clicked - showing loading');
      showPageLoading();
    }
  });
  
  // Enhanced: Listen for composed events from shadow DOM
  document.addEventListener('shopify:payment_button:clicked', function() {
    console.log('Payment button clicked event detected');
    showPageLoading();
  });
  
  // Removed pageshow listener here - now handled globally above
}

// Global functions for loading state management
function showPageLoading() {
  if (!pageLoadingOverlay) return;
  
  pageLoadingOverlay.classList.add('visible');
  pageLoadingOverlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  
  // Clear any existing timeout
  if (loadingTimeout) {
    clearTimeout(loadingTimeout);
  }
  
  // Enhanced: Shorter timeout for better UX (3 seconds instead of 10)
  loadingTimeout = setTimeout(() => {
    console.log('Loading timeout reached - auto-hiding');
    hidePageLoading();
  }, 3000);
}

function hidePageLoading() {
  // Handle both our created overlay and any stray overlays
  if (pageLoadingOverlay) {
    pageLoadingOverlay.classList.remove('visible');
    pageLoadingOverlay.setAttribute('aria-hidden', 'true');
  }
  
  // Also find and hide any existing overlays (edge case handling)
  const existingOverlays = document.querySelectorAll('.page-loading-overlay');
  existingOverlays.forEach(overlay => {
    overlay.classList.remove('visible');
    overlay.setAttribute('aria-hidden', 'true');
  });
  
  // Reset body overflow
  document.body.style.overflow = '';
  
  // Clear timeout
  if (loadingTimeout) {
    clearTimeout(loadingTimeout);
    loadingTimeout = null;
  }
}
